export const ERROR_FIRST_NAME = 'First name is required'
export const ERROR_DOCTOR_NAME = 'Please enter a valid doctor name'
export const ERROR_LAST_NAME = 'Please enter a valid last name'
export const ERROR_EMAIL = 'Please enter a valid email ID'
export const ERROR_MOBILE = 'Please provide a mobile number.'
export const ERROR_UID_MOBILE = 'UID or Mobile Number Required.'
export const ERROR_VALID_MOBILE = 'Please enter a valid mobile number'
export const ERROR_DENTAL_COUNCIL_NAME = 'Please select a Dental Council Name.'
export const ERROR_DCI_NUMBER = 'Please enter a valid DCI number'
export const ERROR_SPECIALIZATION = 'Please enter a valid specialization'
export const ERROR_PASSWORD = 'Please provide a password.'
export const ERROR_CONFIRM_PASSWORD = 'Please confirm your password.'
export const ERROR_TERMS_AND_CONDITIONS =
  'Please agree to the terms & conditions and privacy policy.'
export const ERROR_DATE_OF_BIRTH = 'Please provide a date of birth.'

export const ERROR_DATE_OF_BIRTH_PROPER =
  'Please enter a valid date of birth to ensure you are above 18 years of age'
export const ERROR_ORGANIZATION_NAME = 'Please provide an organization name.'
export const ERROR_GST_NUMBER = 'Please provide a GST number.'
export const ERROR_VALID_GST_NUMBER = 'Please provide a valid GST number.'
export const ERROR_COUNTRY = 'Please enter a valid country'
export const ERROR_STATE = 'Please enter a valid state'
export const ERROR_CITY = 'Please enter a valid city'
export const ERROR_ADDRESS = 'Please provide an address'
export const ERROR_ADDRESS_TYPE = 'Please provide an address type.'
export const ERROR_PINCODE = 'Please provide a pincode'
export const ERROR_PRACTICE_LOCATION_NAME = 'Please enter a valid clinic name.'
export const ERROR_PRACTICE_LOCATION_DOCTOR_NAME = 'Practice location doctor name is required'
export const ERROR_PRACTICE_LOCATION_INCHARGE_DOCTOR_NAME =
  'Practice location incharge doctor name is required'
export const ERROR_PRACTICE_LOCATION_ADDRESS = 'Please enter a valid clinic address'
export const ERROR_PRACTICE_LOCATION_STATE = 'Please enter a valid state'
export const ERROR_PRACTICE_LOCATION_CITY = 'Please enter a valid city'
export const ERROR_PRACTICE_LOCATION_COUNTRY = 'Please enter a valid country'
export const ERROR_PRACTICE_LOCATION_PINCODE = 'Please enter a valid pincode'
export const ERROR_PRACTICE_LOCATION_WEBSITE_URL = 'Please enter a valid website URL'
export const ERROR_PATIENT_NAME = 'Please enter a valid Patient Name'
export const ERROR_PATIENT_FIRST_NAME = 'Accept'
export const ERROR_PATIENT_LAST_NAME = 'Accept'
export const ERROR_PATIENT_MOBILE = 'Accept'
export const ERROR_PATIENT_TREATMENT_TYPE = 'Accept'
export const ERROR_NO_ZERO = 'Please input the total number of aligners; it cannot be zero.'
export const ERROR_ALIGNER_BRAND_NAME = 'Aligner brand name required'
export const ERROR_EACH_WEAR_ALIGNER_DAY = 'No. of days to wear each aligner required'
export const ERROR_TOTAL_NUMBER = 'Total aligner set is required'
export const ERROR_TOTAL_NUMBER_ADD_ALIGNER =
  'Total aligner should be greater than the current aligner'
export const ERROR_RECOMMENDED_DAILY_HOURS = 'Recommended hours is required'
export const ERROR_CURRENT_ALIGNER_SET = 'Current Aligner Set is required'
export const ERROR_CURRENT_ALIGNER_SET_WORN_DAYS =
  'Number of days Aligner set has been worn for is required'
export const ERROR_UPPER_START = 'Required Start'
export const ERROR_UPPER_TOTAL = 'Required Total'
export const ERROR_UPPER_END = 'Required End'
export const ERROR_LOWER_START = 'Required Start'
export const ERROR_LOWER_TOTAL = 'Required Total'
export const ERROR_LOWER_END = 'Required End'
export const ERROR_ONE_FIELD_ONE = 'At least one field should be 1'
export const ERROR_END_GREATER_THAN_START = 'End must be greater than Start'
export const ERROR_START_LESSER_THAN_END = 'Start must be lesser than End'
export const ERROR_LOWER_END_LESS_THAN_UPPER_START = 'Lower End should be less than Upper Start'
export const ERROR_LOWER_UPPER_GAP =
  'If upper and lower jaw aligners have different series, user is required to maintain its serial order number for both.'
export const ERROR_LOWER_UPPER_NO_GAP =
  'The Lower Jaw Start Series Number should be less than or equal to the Upper Jaw End Series Number.'
export const ERROR_CURRENT_LESS_THAN_TOTAL =
  'Current Aligner Set Number must be less than or equal to Total Number'
export const ERROR_APPOINTMENT_DATE = 'Date is required'
export const ERROR_APPOINTMENT_TIME = 'Selected time must be greater than current time'
export const ERROR_CHANGE_WEAR_DAYS = 'Change wear days is required'
export const ERROR_JAWS = 'Please select jaw type'
export const ERROR_EDIT_START_DATE = 'Start date is required'
export const ERROR_EDIT_END_DATE = 'End date is required'
export const ERROR_EDIT_END_DATE_GREATER_THAN_START_DATE =
  'End Date must be greater than Start Date'
export const ERROR_EDIT_END_DATE_DIFF_START_DATE = 'Difference should not be more than 150 days'
export const ERROR_ADD_PLAN_NAME = 'Plan name is required'

export const ERROR_ADD_PLAN_SUBTITLE = 'Sub name is required'
export const ERROR_ADD_PLAN_ORIGINAL_PRICE = 'Original price is required'
export const ERROR_ADD_PLAN_PLAN_PRICE = 'Plan price is required'
export const ERROR_NO_OF_PATIENTS_TRACKED = 'No of patients tracked required'
export const ERROR_NAME = 'Name is required'
export const ERROR_MESSAGE = 'Message is required'
export const ERROR_TOTAL_PATIENT_TRACKED = 'Total patients tracked is required'
export const ERROR_PRICE = 'Price is required'
export const ERROR_DISCOUNT = 'Discounted price is required'
export const ERROR_SAVING = 'Savings/Discount is required'
export const ERROR_PER_PATIENTS_PRICING = 'Per patient pricing price is required'
export const ERROR_PER_PRICING_INCLUDE_FREE =
  'Per patient price including free patients is required'
export const ERROR_PRICE_PATIENTS_AFTER_BUNDLED = 'Price per patient after bundle is required'
export const ERROR_PRODUCT_NAME = 'Product name is required'
export const ERROR_FREE_CLOUD = 'Free cloud storage required'
export const ERROR_EFFECTIVE_PRICE_PER_PATIENT = 'Effective price per patient is required'
export const ERROR_FREE_PATIENT = 'First two patients free is required'
export const ERROR_DOCTOR_WEB_APP = 'Doctor web application is required'
export const ERROR_PATIENT_MOB_APP = 'Patient mobile app is required'
export const ERROR_ALIGNER_TRACKING_MODULE = 'Treatment tracking module is required'
export const ERROR_SUPPORT_VIA_EMAIL = 'Support via email is required'
export const ERROR_SUPPORT_VIA_MOBILE = 'Support via phone is required'
export const ERROR_WHITE_LABELLING = 'White labelled offering is required'
export const ERROR_CUSTOM_DOMAIN = 'Custom domain is required'
// New 15-09-2023
export const ERROR_FEEDBACK = 'Feedback is required'
export const ERROR_ALIGNER_START_DATE = 'Aligner start date is required'
export const ERROR_START_DATE_REQUIRED = 'Start date is required'

export const ERROR_NOTES = 'Notes required'
export const ERROR_TREATMENT_TYPE = 'Please select the treatment type'
export const ERROR_HEALTH_RECORD_TITLE = 'Title required'
export const ERROR_ALIGNER_SET = 'Aligner Set Number is required'
export const ERROR_SEQUENCE_OF_JAWS =
  'Please assign all aligners to either or both jaws. If you do not want to set up separately, please untick the checkbox'

//ERROR VALIDATION MESSAGE
//max
export const ERROR_MAX_6_CHAR = 'Maximum 6 characters'
export const ERROR_MAX_12_CHAR = 'Maximum 12 characters'
export const ERROR_MAX_15_CHAR = 'Maximum 15 characters'
export const ERROR_MAX_18_CHAR = 'Maximum 18 characters'
export const ERROR_MAX_20_CHAR = 'Maximum 20 characters'
export const ERROR_MAX_25_CHAR = 'Maximum 25 characters'
export const ERROR_MAX_30_CHAR = 'Maximum 30 characters'
export const ERROR_MAX_40_CHAR = 'Maximum 40 characters'
export const ERROR_MAX_50_CHAR = 'Maximum 50 characters'
export const ERROR_MAX_99_CHAR = 'Maximum 99 characters'
export const ERROR_MAX_100_CHAR = 'Maximum 100 characters'
export const ERROR_MAX_128_CHAR = 'Maximum 128 characters'
export const ERROR_MAX_150_CHAR = 'Maximum 150 characters'
export const ERROR_MAX_200_CHAR = 'Maximum 200 characters'
export const ERROR_MAX_250_CHAR = 'Maximum 250 characters'
export const ERROR_MAX_255_CHAR =
  'Maximum character limit exceeded. Please limit your input to 50 characters.'
export const ERROR_MAX_300_CHAR = 'Maximum 300 characters'
export const ERROR_MAX_500_CHAR = 'Maximum 500 characters'
export const ERROR_MAX_1000_CHAR = 'Maximum 1000 characters'
export const ERROR_MAX_2048_CHAR = 'Maximum 2048 characters'
export const ERROR_MAX_10_NUMBER = 'Maximum 10 numbers'
export const ERROR_MAX_99_NUMBER = 'Maximum 99 number'
export const ERROR_MAX_150_NUMBER = 'Maximum 150 number'
export const ERROR_MAX_24_NUMBER = 'Maximum 24 number'
export const ERROR_MAX_6_NUMBER = 'Maximum 6 numbers'
export const ERROR_MAX_7_NUMBER = 'Maximum 7 numbers'
export const ERROR_MAX_2_SYMBOLS = 'Maximum 2 symbols'
// min
export const ERROR_MIN_0_CHAR = 'Minimum 0 characters'
export const ERROR_MIN_1_CHAR = 'Minimum 1 characters'
export const ERROR_MIN_2_CHAR = 'Minimum 2 characters'
export const ERROR_MIN_3_CHAR = 'Minimum 3 characters'
export const ERROR_MIN_5_CHAR = 'Minimum 5 characters required'
export const ERROR_MIN_6_CHAR = 'Minimum 6 characters'
export const ERROR_MIN_8_CHAR = 'Minimum 8 characters'
export const ERROR_MIN_10_CHAR = 'Minimum 10 characters'
export const ERROR_MIN_20_CHAR = 'Minimum 20 characters'
export const ERROR_MIN_24_CHAR = 'Minimum 24 characters'
export const ERROR_MIN_30_CHAR = 'Minimum 30 characters'
export const ERROR_MIN_40_CHAR = 'Minimum 40 characters'
export const ERROR_MIN_50_CHAR = 'Minimum 50 characters'
export const ERROR_MIN_0_SYMBOL = 'Minimum 0 symbols'
export const ERROR_MIN_1_SYMBOL = 'Minimum 1 symbols'
export const ERROR_MIN_2_SYMBOL = 'Minimum 2 symbols'
export const ERROR_MIN_0_NUMBER = 'Minimum 0 number'
export const ERROR_MIN_1_NUMBER = 'Minimum 1 number'
export const ERROR_MIN_2_NUMBER = 'Minimum 2 number'
export const ERROR_MIN_3_NUMBER = 'Minimum 3 number'
export const ERROR_MIN_6_NUMBER = 'Minimum 6 number'
export const ERROR_MIN_10_NUMBER = 'Minimum 10 digit numbers'
export const ERROR_MIN_ALIGNER_SET = 'Aligner Set Number is required'

export const ERROR_ONLY_ALPHABETIC = 'Please remove any spaces, special characters or numbers'
export const ERROR_ONLY_ALPHA_NUMERIC = 'Please remove any spaces, special characters'
export const ERROR_ONLY_NUMERIC = 'Accept'
export const ERROR_ONLY_TWO_COMMA = 'Accept'
export const ERROR_SINGLE_QUOTE = `Only one single quote (") is allowed`
export const ERROR_CONSECUTIVE_SPACE = 'Please remove any spaces, special characters'
export const ERROR_CONSECUTIVE_SPACE1 = 'Please remove consecutive spaces'

export const ERROR_MAIL_FORMAT = 'Please enter a valid email address'
export const ERROR_PASSWORD_LOGIN_FORMAT = 'Please enter a valid password.'
export const ERROR_MOBILE_FORMAT = 'Invalid mobile number format'
export const ERROR_PASSWORD_FORMAT =
  'Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one number, and one special character'
export const ERROR_PASSWORD_NOT_MATCH = 'Passwords do not match.'

// MESSAGE TEXT
export const MESSAGE_OTP_SENT = 'An OTP has been sent and will expire in '
export const MESSAGE_INVALID_OTP = 'The provided details are invalid.'
export const MESSAGE_EXPIRY_OTP = 'OTP verification has expired. Please request a new OTP.'
export const MESSAGE_RESEND_OTP = 'Did not receive OTP?'
export const MESSAGE_EMAIL_SENT = 'Email verification sent successfully. Please check your inbox.'

//PLACEHOLDERS
export const PLACEHOLDER_FIRST_NAME = 'First Name'
export const PLACEHOLDER_LAST_NAME = 'Last Name'
export const PLACEHOLDER_EMAIL = 'Email'
export const PLACEHOLDER_MOBILE_NUMBER = 'Mobile Number'
export const PLACEHOLDER_DCI_NUMBER = 'DCI Registration Number'
export const PLACEHOLDER_DENTAL_COUNCIL_NAME = 'DCI Registration Number'
export const PLACEHOLDER_CITY_NAME = 'City Name'
export const PLACEHOLDER_STATE_NAME = 'State Name'
export const PLACEHOLDER_COUNTRY_NAME = 'Country Name'
export const PLACEHOLDER_SPECIALIZATION = 'Specialization'
export const PLACEHOLDER_PASSWORD = 'Password'
export const PLACEHOLDER_CONFIRM_PASSWORD = 'Confirm Password'
export const PLACEHOLDER_DATE_OF_BIRTH = 'Date Of Birth'
export const PLACEHOLDER_ORGANIZATION_NAME = 'Organization Name'
export const PLACEHOLDER_GST_NUMBER = 'GST Number'
export const PLACEHOLDER_CITY_DROPDOWN = 'Select a city'
export const PLACEHOLDER_STATE_DROPDOWN = 'Select a state'
export const PLACEHOLDER_COUNTRY_DROPDOWN = 'Select a country'
export const PLACEHOLDER_ADDRESS_TYPE = 'Select a Address Type'
export const PLACEHOLDER_ADDRESS = 'Add Address'
export const PLACEHOLDER_PINCODE = 'Zipcode'
export const PLACEHOLDER_PRACTICE_LOCATION_NAME = 'Practice Location Name'
export const PLACEHOLDER_PRACTICE_LOCATION_DR_NAME = 'Doctor Name'
export const PLACEHOLDER_PRACTICE_INCHARGE_DR_LOCATION_NAME =
  'Practice Location Incharge Doctor Name'
export const PLACEHOLDER_PRACTICE_WEBSITE = 'Website URL'
export const PLACEHOLDER_PATIENT_FIRST_NAME = 'Patient First Name'
export const PLACEHOLDER_PATIENT_LAST_NAME = 'Patient Last Name'
export const PLACEHOLDER_UID_MOBILE = 'UID / Mobile Number'
export const PLACEHOLDER_PATIENT_NAME = 'Patient name is required'
export const PLACEHOLDER_PATIENT_MOBILE = 'Mobile number is required'
export const PLACEHOLDER_PATIENT_TREATMENT_TYPE = 'Treatment type is required'
export const PLACEHOLDER_ALIGNER_BRAND_NAME = 'Aligner Brand Name'
export const PLACEHOLDER_EACH_WEAR_ALIGNER_DAY = 'Duration of Wear for Each Aligner'
export const PLACEHOLDER_TOTAL_NUMBER = 'Total number of aligner sets'
export const PLACEHOLDER_RECOMMENDED_DAILY_HOURS = 'Recommended daily wear hours'
export const PLACEHOLDER_CURRENT_ALIGNER_SET = 'Current Aligner Set'
export const PLACEHOLDER_CURRENT_ALIGNER_SET_WORN_DAYS =
  'No. of days current aligner set has been worn for '
export const PLACEHOLDER_UPPER_START = 'Start'
export const PLACEHOLDER_UPPER_TOTAL = 'Total'
export const PLACEHOLDER_UPPER_END = 'End'
export const PLACEHOLDER_LOWER_START = 'Start'
export const PLACEHOLDER_LOWER_TOTAL = 'Total'
export const PLACEHOLDER_LOWER_END = 'End'
export const PLACEHOLDER_FUTURE_TREATMENT_DATE = 'Accept'
export const PLACEHOLDER_CHANGE_TOTAL_ALIGNER = 'Change total number of aligner sets'
export const PLACEHOLDER_CHANGE_ALIGNER = 'Change total number of aligner sets'

// ALERT MESSAGE
export const ALERT_TITLE_VERIFY_MOBILE = 'Mobile Number'
export const ALERT_TEXT_VERIFY_MOBILE = 'Kindly verify your mobile number with an OTP.'
export const ALERT_TITLE_REGISTRATION = 'Registration'
export const ALERT_TITLE_RELOGIN = 'Login again'
export const ALERT_TITLE_LOGIN = 'Login'
export const ALERT_TEXT_EMAIL_PASSWORD_NOT_MATCH = 'Username or password incorrect.'
export const ALERT_TITLE_OTP_VERIFICATION = 'OTP Verification'
export const ALERT_TITLE_OTP_RESEND = 'OTP Resend'
export const ALERT_TEXT_OTP_VERIFIED = 'OTP Verified Successfully'
export const ALERT_TITLE_OTP_AUTHENTICATION = 'OTP authentication'
export const ALERT_TITLE_FORGET_PASSWORD = 'Forgot Password'
export const ALERT_TITLE_UPDATE_PROFILE = 'Update Profile'
export const ALERT_TITLE_EMAIL_VERIFICATION = 'Email Verification'
export const ALERT_TITLE_ADD_BILLING_ADDRESS = 'Add Billing Address'
export const ALERT_TEXT_ADD_BILLING_ADDRESS = 'Billing Address could not be added'
export const ALERT_TITLE_VALIDATION_ADDRESS = 'Validation'
export const ALERT_TEXT_VALIDATION_ADDRESS =
  'You already have a primary address. Make a secondary address & proceed'
export const ALERT_TITLE_DELETE_ADDRESS = 'Delete Address'
export const ALERT_TEXT_DELETE_ADDRESS = 'Are you sure you want to delete this address ?'
export const ALERT_TITLE_DOCTOR_INFO = 'Doctor Info'
export const ALERT_TITLE_UPDATE_BILLING_ADDRESS = 'Update Billing Address'
export const ALERT_TITLE_DELETE_BILLING_ADDRESS = 'Delete Billing Address'
export const ALERT_TITLE_ADD_PRACTICE_LOCATION = 'Add Practice Location'
export const ALERT_TITLE_PRACTICE_LOCATION = 'Practice Location'
export const ALERT_TITLE_UPDATE_PRACTICE_LOCATION = 'Update Practice Location'
export const ALERT_TEXT_ADD_PRACTICE_LOCATION_DETAILS_WRONG =
  'The Practice Location details are incorrect'
export const ALERT_TITLE_INVITE_PATIENT = 'Invite Patient'
export const ALERT_TITLE_PATIENT_NOT_FOUND = 'Patient not found'
export const ALERT_TITLE_TREATMENT = 'TREATMENT'
export const ALERT_TITLE_UPDATE_TIMELINE_TREATMENT = 'Update Treatment Timeline'
export const ALERT_TITLE_PREV_DEACTIVATE_TREATMENT = 'Deactivate Previous Treatment'
export const ALERT_TEXT_PREV_DEACTIVATE_TREATMENT =
  'Are you sure you want to deactivate the previous treatment?'
export const ALERT_TITLE_DEACTIVATE_TREATMENT = 'Deactivate Treatment'
export const ALERT_TEXT_DEACTIVATE_TREATMENT = 'Current Active Treatment has been Deactivated!'
export const ALERT_TITLE_CREATE_ALIGNER_JOURNEY = 'Create Aligner Journey'
export const ALERT_TITLE_UPDATE_ALIGNER_JOURNEY = 'Update Treatment Timeline'
export const ALERT_TITLE_ADD_HEALTH_RECORD = 'Add Health Record'
export const ALERT_TITLE_ADD_HEALTH_RECORD_PHOTOS = 'Add Health Record Photos'
export const ALERT_TEXT_ADD_HEALTH_RECORD_PHOTOS =
  'The file upload is limited to a maximum of five files only.'
export const ALERT_TITLE_ADD_GALLERY_PHOTOS = 'Add Gallery Photos'
export const ALERT_TITLE_UPDATE_GALLERY_PHOTOS = 'Update Appointment'
export const TEXT_CHAT_PHOTO_VALIDATION_FOR_GALLERY =
  'Please ensure that you only upload images in the following formats: JPG, JPEG, HEIC and PNG.'
export const TEXT_CHAT_PHOTO_VALIDATION =
  'Please ensure that you only upload images in the following formats: JPG, JPEG, HEIC, PNG, and PDF.'
export const ALERT_TITLE_UPDATE_PLAN = 'Update Plan'
export const ALERT_TEXT_UPDATE_PLAN = 'Plan updated successfully'
export const ALERT_TITLE_ADD_PLAN = 'Add Plan'
export const ALERT_TEXT_ADD_PLAN = 'Plan added successfully'
export const ALERT_TITLE_INCORRECT_LOGIN_DETAILS = 'Invalid Login Details'
export const ALERT_TEXT_INCORRECT_LOGIN_DETAILS = 'The login details are incorrect'
export const ALERT_TITLE_PLAN_LIST = 'Plan List'

// BACKEND ALERT MESSAGE
export const ALERT_ALREADY_REGISTERED_MOBILE =
  'This mobile number already exists. Kindly login or use another mobile number'
export const ALERT_MESSAGE_LOGGED_IN = 'User is currently logged in on another device.'
export const ALERT_MESSAGE_USERNAME_AND_PASSWORD_DID_NOT_MATCH =
  'Username and password did not match'
export const ALERT_LOGIN_SUCCESSFUL = 'Login successfully'

// Message
export const TEXT_INVALID_MOB_UID = 'Invalid Mobile Number or UID.'

export const TEXT_SAMPLE_PRACTICE_LOCATION = 'Smera Dental Clinic - on Apollo 24|7 (Sample)'
export const BASE_MESSAGE = ' is required'

export const TEXT_LOADING = 'Loading...'
export const TEXT_CANCEL = 'Cancel'
export const TEXT_UPDATE_WEAR_DAYS = 'Update Wear Days'
export const TEXT_CONFIRM_UPDATE = 'Confirm & Update'
export const TEXT_SIGN_IN = 'Sign In'
export const TEXT_SIGN_ME_UP = 'Sign me up!'
export const TEXT_CONTINUE = 'Continue'
export const TEXT_ADD_CLINIC = 'Add Clinic'
export const TEXT_FINALIZE_SETUP = 'Finalize & Set-up plan'
export const TEXT_SEND_TO_PATIENT = 'Send to Patient'
export const TEXT_UPDATE_CLINIC = 'Update Clinic'
export const TEXT_INVITE = 'Invite'
export const TEXT_UPDATE_DETAILS = 'Update details'
export const TEXT_ADD_PHOTOS = 'Add Photos'
export const TEXT_INCORRECT_COMBINATIONS_COUNTRY_STATE_CITY =
  'Please select the country, state, & city correctly'
export const fieldErrorMessages = {
  TEXT_USER_ID: 'User Id' + BASE_MESSAGE,
  TEXT_DOCTOR_ID: 'Doctor Id' + BASE_MESSAGE,
  TEXT_PATIENT_ID: 'Patient Id' + BASE_MESSAGE,
  TEXT_LOGIN_EMAILID: 'Email Id' + BASE_MESSAGE,
  TEXT_LOGIN_PASSWORD: 'Password' + BASE_MESSAGE,
  TEXT_OTP: 'OTP' + BASE_MESSAGE,
  TEXT_DCI_NUMBER: 'DCI Number' + BASE_MESSAGE,
  TEXT_DENTAL_COUNCIL_NAME: 'Dental Council Name' + BASE_MESSAGE,
  TEXT_FIRST_NAME: 'Firstname' + BASE_MESSAGE,
  TEXT_EMAIL: 'EmailId' + BASE_MESSAGE,
  TEXT_MOBILE: 'Mobile Number' + BASE_MESSAGE,
  TEXT_PRACTICE_LOCATION_ID: 'Practice Location Id' + BASE_MESSAGE,
  TEXT_PRACTICE_LOCATION_NAME: 'Practice Location Name' + BASE_MESSAGE,
  TEXT_PRACTICE_LOCATION_TYPE: 'Practice Location Type' + BASE_MESSAGE,
  TEXT_ADDRESS: 'Address' + BASE_MESSAGE,
  TEXT_CITY: 'City' + BASE_MESSAGE,
  TEXT_STATE: 'State' + BASE_MESSAGE,
  TEXT_COUNTRY: 'Country' + BASE_MESSAGE,
  TEXT_WEBSITE_URL: 'Website Url' + BASE_MESSAGE,
  TEXT_MESSAGE: 'Message' + BASE_MESSAGE,
  TEXT_PATIENT_DETAILS: 'Patient Details' + BASE_MESSAGE,
  TEXT_ALIGNER_NUMBER: 'Aligner Number' + BASE_MESSAGE,
  CHAT_MESSAGE_LENGTH_EXCEEDED:
    'Message exceeds 5000 characters. Shorten your message and try again.',
}
